import React, { Fragment } from 'react';
import Article, { ArticleSection } from './Article';
import Graf from './Graf';
import styles from './styles.mod.scss';
import { Paragraph, SecondaryH5, H5 } from 'scy/text';
import { width100 } from 'scy/utils.mod.scss';
import { snippets, levels } from './perks_config';
import { flex, column, spaceBetween, centerItems } from 'scy/flex.mod.scss';
import classnames from 'classnames';
import CheckmarkGrayIcon from 'images/icons/checkmark-gray.svg?react-svg';
import ShoppingBagIcon from 'images/icons/shopping-bag-filled.svg?react-svg';

export default function LoyaltyProgramBenefits() {
  return (
    <Article
      asideTitle="Contact"
      lastUpdated="August 24, 2020"
      asideBody={<a href="mailto:support@saucey.com">support@saucey.com</a>}
    >
      <ArticleSection title="How it works">
        <Paragraph>
          There are two different ways to earn loyalty points:
        </Paragraph>
        <ol className={styles.ol}>
          <li>
            Make a purchase in the mobile app or website.
            <ShoppingBagIcon
              className={styles.shoppingBagIcon}
              height={18}
              width={18}
            />
            $1 <span>&#61;</span> 10 points*, easy as that!
          </li>
          <li>Complete an action!</li>
        </ol>
        <Paragraph>
          The list of actions and their point totals can be found after you are
          logged on to your account on the app or website!
        </Paragraph>
        <RewardsSnippet />
        <Paragraph>
          Examples include downloading the app, sending your first invite, etc.!
        </Paragraph>
        <Graf>
          *Points are calculated from your order subtotal (pre-tax, fees, etc.),
          and will be rounded to the closest $0.50.
        </Graf>
      </ArticleSection>
      <ArticleSection title={`What are the different levels?`}>
        <Graf>There are different loyalty program levels:</Graf>
        <Levels />
        <Paragraph>
          For any level, please make sure your contact information is up to date
          and that you are subscribed to push notifications, emails, etc. as
          perks and offers may be distributed through such messages.
        </Paragraph>
        <Graf>
          *Further details will be provided upon reaching Black status.
        </Graf>
      </ArticleSection>
      <ArticleSection title="Help! I don't see my points!">
        <Paragraph>
          Points will be awarded after an order or action step is completed!
          They can take a couple of minutes to appear, so do a quick stretch,
          take a sip, and if you&#39;re still not seeing them, please feel free
          to email us at&nbsp;
          <a href="mailto:support@saucey.com">support&#64;saucey.com</a> and
          we&#39;ll take a look &#59;&#41;
        </Paragraph>
      </ArticleSection>
    </Article>
  );
}

const RewardsSnippet = () => (
  <div className={classnames(styles.snippetContainer, flex, column)}>
    {snippets.map(snippet => (
      <div
        key={`snippet-${snippet.title}`}
        className={classnames(
          styles.snippet,
          flex,
          spaceBetween,
          centerItems,
          width100
        )}
      >
        <SecondaryH5 className={styles.title} uppercase>
          {snippet.title}
        </SecondaryH5>
        <CheckmarkGrayIcon
          height={14}
          width={14}
          className={styles.levelIcon}
        />
        <SecondaryH5>+{snippet.points.toLocaleString()}</SecondaryH5>
      </div>
    ))}
  </div>
);

const Levels = () => (
  <div className={styles.levels}>
    {levels.map(level => (
      <Fragment key={`status-${level.status}`}>
        <div className={classnames(styles.levelTitle, flex, centerItems)}>
          <img
            src={level.icon}
            width="26"
            height="26"
            alt={`${level.status} status`}
          />
          <H5 uppercase>{level.status} status</H5>
        </div>
        <ul>
          {level.line_items.map(item => (
            <li key={`item-${item}`}>{item}</li>
          ))}
        </ul>
      </Fragment>
    ))}
  </div>
);
